"use strict";exports.spacingForButton=(t,i)=>{let n;n="primary"===t||"secondary"===t?"3X":"textLinkCaret"===t?"6X":"textLink"===t?"4X":0;return{rightSpacing:n,bottomSpacing:"3X"}},exports.spacingForTextLink=(t,i)=>{let n="small"===i?"5X":"3X";return"textLink"===t&&(n="5X"),{topSpacing:"small"===i?"3X":"1X",rightSpacing:"4X",bottomSpacing:n}},exports.spacingForTextLinkCaret=t=>({topSpacing:"3X",rightSpacing:"6X",bottomSpacing:"textLink"===t?"5X":"3X"});



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/buttons/cjs/util/spacingUtil.js
// module id = 850
// module chunks = 0